<template>
  <div class="product-form product-form--basic-info row">
    <div class="w-100" v-if="isLoaded">
      <RolledSection>
        <div slot="header">Informacje podstawowe</div>

        <div slot="body" class="row product-form--gray pb-4 mb-4">
          <div class="col-24 col-xl-8">
            <InputSimple
              :object="product"
              label="Nazwa*"
              fieldName="name"
              type="text"
            ></InputSimple>
          </div>
          <div class="col-24 col-xl-8" v-if="!product.have_variants">
            <InputSimple
              :object="product"
              label="Kod produktu*"
              fieldName="index"
              type="text"
            ></InputSimple>
          </div>
          <div class="col-24 col-xl-8" v-if="!product.have_variants">
            <InputSimple
              :object="product"
              label="Kod EAN-13*"
              fieldName="ean13"
              type="text"
            ></InputSimple>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.categories"
              :object="product"
              :isLoading="isLoading"
              fieldName="category_id"
              label="Kategoria*"
              @additionalFunction="changeCategory"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.product_lines"
              :object="product"
              :isLoading="isLoading"
              fieldName="product_line_id"
              label="Linia produktowa"
              :clearable="true"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.brands"
              :object="product"
              :isLoading="isLoading"
              fieldName="brand_id"
              label="Marka"
              :clearable="true"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.markets"
              :object="product"
              :isLoading="isLoading"
              fieldName="markets"
              label="Domena*"
              :multiple="true"
              :clearable="true"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <Checkbox
              :object="product"
              label="Status"
              fieldName="status"
            ></Checkbox>
          </div>
          <div
            class="col-24 col-xl-8"
            v-if="[39, 40, 41].includes(product.category_id)"
          >
            <Checkbox
              :object="product"
              label="Widoczny w kalkulatorze"
              fieldName="is_in_calculator"
            ></Checkbox>
          </div>
          <div class="col-24 col-xl-8" v-if="!product.have_variants">
            <Checkbox
              :object="product"
              label="Nowość"
              fieldName="is_new"
            ></Checkbox>
          </div>
          <div class="col-24 col-xl-8" v-if="!product.have_variants">
            <Checkbox
              :object="product"
              label="Występuje w zestawie"
              fieldName="is_included_in_set"
            ></Checkbox>
          </div>
          <div class="col-24 col-xl-8" v-if="!product.have_variants">
            <Checkbox
              :object="product"
              label="Kolor uniwersalny"
              fieldName="universal_color"
            ></Checkbox>
          </div>
        </div>
      </RolledSection>
      <RolledSection>
        <div slot="header">Opis</div>
        <div slot="body" class="row product-form--gray pb-4 mb-4">
          <div class="col-24">
            <EditorForm fieldName="description" :object="product" label="Opis">
            </EditorForm>
          </div>
        </div>
      </RolledSection>
      <RolledSection>
        <div slot="header">Pola dodatkowe</div>
        <div slot="body" class="row product-form--gray pb-4 mb-4">
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.orgin_countries"
              :object="product"
              :isLoading="isLoading"
              fieldName="orgin_country_id"
              label="Kraj pochodzania"
              :clearable="true"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.warranties"
              :object="product"
              :isLoading="isLoading"
              fieldName="warranty_id"
              label="Gwarancja"
              :clearable="true"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.certificates"
              :object="product"
              :isLoading="isLoading"
              :multiple="true"
              fieldName="certificates"
              label="Certyfikaty"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.awards"
              :object="product"
              :isLoading="isLoading"
              :multiple="true"
              fieldName="awards"
              label="Nagrody"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.destinies"
              :object="product"
              :isLoading="isLoading"
              :multiple="true"
              fieldName="destinies"
              label="Przeznaczenie"
            ></InputTreeselect>
          </div>
          <div class="col-24 col-xl-8">
            <InputTreeselect
              :options="dictionaries.materials"
              :object="product"
              :isLoading="isLoading"
              fieldName="materials"
              label="Materiał produktu"
              :multiple="true"
            ></InputTreeselect>
          </div>
        </div>
      </RolledSection>
      <RolledSection v-if="!product.have_variants">
        <div slot="header">Dane logistyczne</div>
        <div slot="body">
          <LogisticsData
            :logisticsData="product.logistics_data"
            :dictionaries="dictionaries"
          />
        </div>
      </RolledSection>
      <SetProducts
        v-if="!product.have_variants && product.is_included_in_set"
        :setProducts="product.set_products"
        @addProduct="addSetProduct"
        @deleteProduct="deleteSetProduct"
        type="similar"
        title="Produkty w zestawie"
      ></SetProducts>
      <ConnectProducts
        :product="product"
        type="similar"
        title="Produkty polecane"
      ></ConnectProducts>
    </div>
    <div v-else>Loading...</div>
  </div>
</template>
<script>
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
import EditorForm from "./forms/EditorForm";
import ConnectProducts from "./ConnectProducts.vue";
import SetProducts from "./SetProducts.vue";
import InputTreeselect from "./forms/InputTreeselect.vue";
import InputSimple from "./forms/InputSimple.vue";
import Checkbox from "./forms/Checkbox.vue";
import RolledSection from "./forms/RolledSection.vue";
import LogisticsData from "./LogisticsData.vue";

export default {
  data() {
    return {
      isLoaded: true,

      units: [
        {
          id: "mm",
          name: "mm",
        },
        {
          id: "cm",
          name: "cm",
        },
        {
          id: "m",
          name: "m",
        },
      ],
    };
  },
  props: {
    product: {
      type: Object,
      required: false,
    },
    dictionaries: {
      type: Object,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  components: {
    LogisticsData,
    EditorForm,
    ConnectProducts,
    SetProducts,
    InputTreeselect,
    InputSimple,
    Checkbox,
    RolledSection,
  },
  mounted() {
    console.log(this.dictionaries);
    this.$root.$on("saveProduct", () => {
      this.storeProduct();
    });
  },
  beforeDestroy() {
    this.$root.$off("saveProduct");
  },
  methods: {
    changeCategory() {
      axios
        .get(API_BASE_URL + "/categories/" + this.product.category_id)
        .then((response) => {
          this.product.spim_category_id =
            response.data.product_spim_category_id;
        })
        .catch((error) => {
          this.$root.$emit("noticesBox", error.response.data);
        });
    },
    addSetProduct(chosenProduct) {
      this.product.set_products.push({
        product_id: chosenProduct.product_id,
        product_index: chosenProduct.product_index,
        product_name: chosenProduct.product_name,
        variant_id: chosenProduct.variant_id,
        variant_index: chosenProduct.variant_index,
        variant_name: chosenProduct.variant_name,
      });
    },
    deleteSetProduct(chosenProduct) {
      const filtersList = this.product.set_products.filter(function (element) {
        return !(
          element.product_id === chosenProduct.product_id &&
          element.variant_id === chosenProduct.variant_id
        );
      });
      this.product.set_products = filtersList;
    },
  },
};
</script>
